// This is optional but highly recommended
// since it prevents memory leak
import { createIntl, createIntlCache } from "react-intl";

import messages from "./en-US.js";
import type { SelMessageProps } from "./SelMessage.js";

const intlCache = createIntlCache();
export const intl = createIntl(
  {
    locale: "en-US",
    messages: messages,
  },
  intlCache,
);

export const selMessage = (props: SelMessageProps): string => {
  const values = props.values ? { ...msgFormatting, ...props.values } : msgFormatting;
  return intl.formatMessage({ id: props.id }, values) as string;
};

// In case of pure string, mostly in headings, we don't format with html element and bold text
const msgFormatting = {
  emph: ([chunk, ..._otherChunks]) => {
    return chunk;
  },
};
